import React, { useState } from 'react';
import { Container, ThisCard } from './styles';

import IconEtAtiviAtivo from '~/assets/icones/IconEtAtiviAtivo.svg';
import IconEtAtiviAtivoB from '~/assets/icones/IconEtAtiviAtivoB.svg';

function CustomBodyContent({ data }) {
  const [linhaAtiva, setLinhaAtiva] = useState([]);

  return (
    <Container>
      {data?.map((thisData, i) => (
        <ThisCard
          className={
            linhaAtiva === thisData?.id ? 'card-item ativo' : 'card-item'
          }
          {...{ data: thisData, linhaAtiva, setLinhaAtiva }}
          key={thisData?.id || i}
          id={thisData?.id || i}
          index={i}
          ativo={linhaAtiva === thisData?.id ? true : false}
        >
          <div className="card-content">
            <div className="card-body">
              <div className="card-text">
                <p className="descricao">#{thisData?.codigo}</p>
                <p className="titulo">{thisData?.titulo}</p>
              </div>
            </div>
            <img src={localStorage.getItem("tema") == "E" ? IconEtAtiviAtivo : IconEtAtiviAtivoB} alt="Vazio" />
          </div>
          <div className="card-bottom">
            <div className="card-grupo">
              <p className="grupoperfil">{thisData?.posicao + ' ª Etapa'}</p>
            </div>
          </div>
        </ThisCard>
      ))}
    </Container>
  );
}

export default CustomBodyContent;
